import { useEffect, useRef, useState } from 'react';

import {
    Box,
    ClickAwayListener,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IconLogout, IconUser } from '@tabler/icons';
import { BiUser } from 'react-icons/bi';

import { navigate, useLocation } from '@redwoodjs/router';

import MainCard from 'src/components/MainCard/MainCard';
import Transitions from 'src/components/Transitions/Transitions';
import { useAuthContext } from 'src/contexts/AuthProvider';
import useConfig from 'src/hooks/useConfig';

// ==============================|| PROFILE MENU ||============================== //

export const ProfileSection = () => {
    const theme = useTheme();
    const { borderRadius } = useConfig();

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const { logout } = useAuthContext();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleListItemClick = (index: number, route: string) => {
        setSelectedIndex(index);
        navigate(route);
        setOpen(false);
    };

    const location = useLocation();

    useEffect(() => {
        // Check the current location and set the selected index accordingly
        if (location.pathname === '/profile') {
            setSelectedIndex(0);
        } else {
            setSelectedIndex(-1); // Reset the active state for all other routes
        }
    }, [location]);

    return (
        <>
            <Box
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                margin={0}
                padding={0}
                data-testid="profile-menu"
                onClick={() => setOpen((prevOpen) => !prevOpen)}
                sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}
            >
                <BiUser fontSize="20px" style={{ cursor: 'pointer' }} />
            </Box>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                transition
                disablePortal
                placement="bottom-end"
                sx={{ zIndex: 1200 }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={() => setOpen(false)}>
                                <MainCard
                                    border={false}
                                    elevation={16}
                                    content={false}
                                    boxShadow
                                    shadow={theme.shadows[16]}
                                >
                                    <List
                                        component="nav"
                                        sx={{
                                            p: 0,
                                            m: 0,
                                            backgroundColor: 'background.paper',
                                            borderRadius: 1,
                                        }}
                                    >
                                        <ListItemButton
                                            selected={selectedIndex === 0}
                                            onClick={() => handleListItemClick(0, '/profile')}
                                        >
                                            <ListItemIcon>
                                                <IconUser stroke={1.5} size="1.3rem" />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body2">
                                                        My Profile
                                                    </Typography>
                                                }
                                            />
                                        </ListItemButton>

                                        <ListItemButton
                                            data-testid="profile-logout-button"
                                            onClick={logout}
                                        >
                                            <ListItemIcon>
                                                <IconLogout stroke={1.5} size="1.3rem" />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Typography variant="body2">Logout</Typography>
                                                }
                                            />
                                        </ListItemButton>
                                    </List>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
        </>
    );
};
